import DataGrid, { Column } from 'devextreme-react/data-grid';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { formRegisterApi } from '../../../api/formRegisterApi';
import { uploadApi } from '../../../api/uploadApi';
import appInfo from '../../../app-info';
import { DefaultButton, PrimaryButton } from '../../../components/editor/button';
import UploadExcelBtn from '../../../components/file-upload/UploadExcelS3';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import styles from "./FormResultImportModal.module.css";
import SeparatedDataCell from '../../../components/form-register-result/SeparatedDataCell';

const FormResultImportModal = ({ onSuccess, onCancel, chienDichSelectedId }) => {
    const { translate } = useCommonContext();
    const [isSaving, setisSaving] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const componentDidMount = useRef(false);
    const [dataSouce, setDataSouce] = useState([]);
    const [dataSouceValidated, setDataSouceValidated] = useState([]);
    const { dm_coso_id } = useSelector(x => x.coSo)
    const { nam_hoc } = useSelector((x) => x.namHoc);
    const grid = useRef(null);

    const notValidCount = useMemo(() => {
        return dataSouceValidated.filter(x => x.err != "").length;
    }, [dataSouceValidated])

    const hanldeImport = async () => {
        setisSaving(true);
        const res = await formRegisterApi.Import({
            fileName: uploadedFileName,
            sheetIndex: 0,
            dm_chiendich_id: chienDichSelectedId
        }, nam_hoc, dm_coso_id);
        if (!componentDidMount.current) return;
        setisSaving(false);
        if (res.is_success) {
            showNotify({ text: translate('Import thành công '), type: 'success' });
            onSuccess();
        } else {
            showNotify({ type: "error", text: "Có lỗi" });
        }
    }
	useEffect(() => {
		console.log(uploadedFileName);
		componentDidMount.current = true;
		if (uploadedFileName != '') {
			handleValidateImportFile();
		}
	}, [uploadedFileName]);

    const handleValidateImportFile = async () => {
        setisLoading(true);
        const res = await formRegisterApi.ValidateImport({
            fileName: uploadedFileName,
            sheetIndex: 0
        }, nam_hoc, dm_coso_id);
        if (!componentDidMount.current) return;
        setisLoading(false);
        if (res.is_success) {
            setDataSouceValidated(res.data)
        }
    }
    const onBtnExportClick = async () => {
        setisLoading(true);
        grid.current.instance.exportToExcel();
        setisLoading(false);
    };
    return (
        <div>
            <Modal
                open={true}
                size="fullscreen"
                dimmer={'blurring'}
                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
                style={{ marginLeft: 50 }}

            >
                <Modal.Header>
                    <p>Upload từ excel</p>
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <div className='row'>
                            <div className='col-md-12'>

                                <div className={styles.toolbar}>
                                    <div className={styles.before}>
                                        <UploadExcelBtn
											onSuccess={(file) => {
                                                console.log("DMM");
                                                console.log(file.fileNameId);
												setUploadedFileName(file.fileNameId);
											}}
										/>
                                    </div>
                                    <div className={styles.after}>
                                        <a href={`${appInfo.api_url.replace('/api', '')}/TEMPLATE/IMPORT_LEAD.xlsx`}
                                            target={"_blank"}
                                        >{translate("Tải file mẫu")}</a>
                                    </div>
                                    <div className={styles.after} style={{ marginLeft: '10px' }}>
                                        <DefaultButton text={'Xuất Excel'} icon='fas fa-file' onClick={onBtnExportClick} />
                                    </div>
                                </div>

                            </div>
                            {notValidCount > 0 && <div className='col-md-12'>
                                <p style={{ color: "red", marginTop: 10 }}>Có {notValidCount} dòng không hợp lệ</p>
                            </div>}
                            <div className='col-md-12' style={{ marginTop: 10 }}>
                                <DataGrid
                                    dataSource={dataSouceValidated}
                                    ref={grid}
                                    grid={grid}
                                    height={window.innerHeight - 270}
                                    wordWrapEnabled
                                    showColumnLines={true}
                                    showBorders={true}
                                    columnHidingEnabled={false}
                                    columnAutoWidth={false}
                                    rowAlternationEnabled={true}
                                    allowColumnResizing={true}
                                    showRowLines={true}
                                    columnResizingMode={'nextColumn'}
                                    scrolling={{ mode: 'standard' }}
                                >
                                    <Column dataField={"TT"} caption="TT" width={50} />
                                    <Column dataField={"Ten_chien_dich"} width={200} caption="Chiến dịch"
                                        cellRender={(cell) => <SeparatedDataCell value={cell.value} infor={'Chiến dịch'} />}
                                    />
                                    <Column dataField={"Trang_thai"} width={200} caption="Trạng thái"
                                        cellRender={(cell) => <SeparatedDataCell value={cell.value} infor={'Trạng thái'} />}
                                    />
                                    <Column dataField={"Dien_thoai_cha"} width={200} caption="Điện thoại cha"
                                        cellRender={(cell) => <SeparatedDataCell value={cell.value} infor={'Điện thoại cha'} />}
                                    />
                                    <Column dataField={"Ho_ten_cha"} width={200} caption="Họ tên cha"
                                        cellRender={(cell) => <SeparatedDataCell value={cell.value} infor={'Họ tên cha'} />}
                                    />
                                    <Column dataField={"Email_cha"} width={200} caption="Email cha" />
                                    <Column dataField={"Dien_thoai_me"} width={200} caption="Điện thoại mẹ"
                                        cellRender={(cell) => <SeparatedDataCell value={cell.value} infor={'Điện thoại mẹ'} />}
                                    />
                                    <Column dataField={"Ho_ten_me"} width={200} caption="Họ tên mẹ"
                                        cellRender={(cell) => <SeparatedDataCell value={cell.value} infor={'Họ tên mẹ'} />}
                                    />
                                    <Column dataField={"Email_me"} width={200} caption="Email mẹ" />
                                    <Column dataField={"Ho_ten_hoc_sinh"} width={200} caption="Họ tên học sinh" />
                                    <Column dataField={"Khoi_lop"} caption="Khối lớp" />
                                    <Column dataField={"Ghi_chu"} width={200} caption="Ghi chú" />
                                    <Column dataField={"Email_tu_van_vien"} width={200} caption="Email tư vấn viên" />

                                    <Column dataField={"err"} caption="Mã lỗi" cellRender={(cell) => {
                                        return <p style={{ marginBottom: 0, color: 'red', whiteSpace: 'pre-line' }}>{cell.data.err}</p>;
                                    }}
                                        width={300} />
                                </DataGrid>
                            </div>
                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>

                        <DefaultButton text={"Đóng"} onClick={onCancel} />
                        {notValidCount <= 0 &&
                            <PrimaryButton text={"Cập nhật"} onClick={hanldeImport}
                                isLoading={isSaving}
                                disabled={notValidCount > 0} />
                        }
                    </div>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default FormResultImportModal;